export default {"src":"/_next/static/media/faq-icon.67e1cd7b.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};